import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AdminLayout from "../../../AdminLayout";
import DeleteConfirmation from "../../../Components/DeleteConfirmation";
import EmptyContent from "../../../Components/Empty-content/EmptyContent";
import ItemsLoader from "../../../Components/Loader/basic loader/ItemsLoader";
import PaginationComponent from "../../../Components/Pagination";
import TitleBar from "../../../Components/TitleBar";
import { useExpenditureListStore } from "../../../Store/CashControlStore/ExpenditureListStore";
import { useLoaderStore } from "../../../Store/Loader/LoaderStore";
import Heading from "./components/Heading";
import ListItem from "./components/ListItem";

export default function ExpenditureList() {
  const {
    loadItems,
    onReload,
    results,
    pagination,
    queryParams,
    updateParams,
    setLoading,
    deleteTransaction,
    isLoading,
    deletingId,
    isShowDeleteLoader,
  } = useExpenditureListStore();
  const { setLoader } = useLoaderStore();

  const pageLoad = useCallback(async () => {
    setLoader(true);
    await onReload();
    setLoader(false);
  }, []);

  useEffect(() => {
    pageLoad();
    document.body.addEventListener("click", handleClickClosePanelFromOutside);
    return () => {
      document.body.removeEventListener(
        "click",
        handleClickClosePanelFromOutside
      );
    };
  }, []);

  const paginateTo = useCallback(
    async (page) => {
      const queryString = new URLSearchParams({
        ...queryParams,
        page: page,
      }).toString();
      setLoading(true);
      updateParams({ page: page });
      await loadItems(queryString);
      setLoading(false);
    },
    [queryParams]
  );

  const handleClickClosePanelFromOutside = (e) => {
    if (!e.target.className.includes("build-table__item--7")) {
      useExpenditureListStore.setState({
        open_context_id: null,
      });
    }
  };
  const deleteAction = async (e) => {
    e.preventDefault();
    const findTransaction = results?.find((item) => item.id === deletingId);
    await deleteTransaction(deletingId, findTransaction?.payment_mode);
  };

  const cancelConfirmation = (e) => {
    e.preventDefault();
    useExpenditureListStore.setState({
      deletingId: null,
      isShowDeleteLoader: false,
    });
  };

  const { t } = useTranslation();

  return (
    <AdminLayout>
      <TitleBar title={t("Xarajatlar ro'yxati")} />
      <div className="container">
        <Heading />
        {isLoading ? (
          <ItemsLoader size={70} />
        ) : results?.length > 0 ? (
          results?.map((item, index) => {
            return <ListItem item={item} index={index} key={index} />;
          })
        ) : (
          <EmptyContent />
        )}
        <DeleteConfirmation
          showModal={{
            deletingId: deletingId,
            isShowDeleteLoader: isShowDeleteLoader,
          }}
          deleteCallback={deleteAction}
          cancelCallback={cancelConfirmation}
        />
        <PaginationComponent
          context={{ pagination: pagination, queryParams: queryParams }}
          callback={paginateTo}
        />
      </div>
    </AdminLayout>
  );
}
